import type { JSX, ReactNode } from 'react';
import { createContext, useState } from 'react';

export const BLUE_CARD_VARIANTS = ['variant_3', 'variant_4'];

export type Variant = string;

export type ContextValue = {
	noSelectionMadeError: boolean;
	setNoSelectionMadeError: (value: boolean) => void;
	setUserInteracted: (value: boolean) => void;
	userInteracted: boolean;
	variant?: Variant;
	shouldUseBlueCards: boolean;
};

export const SunriseHoldoutExperimentContext = createContext<ContextValue>({
	userInteracted: false,
	setUserInteracted: () => {},
	setNoSelectionMadeError: () => {},
	noSelectionMadeError: false,
	shouldUseBlueCards: false,
});

export function SunriseHoldoutExperimentContextProvider({
	children,
	variant,
}: {
	children: ReactNode;
	variant: string | undefined;
}): JSX.Element {
	const [userInteracted, setUserInteracted] = useState(false);
	const [noSelectionMadeError, setNoSelectionMadeError] = useState(false);
	const shouldUseBlueCards = !!variant && BLUE_CARD_VARIANTS.includes(variant);

	return (
		<SunriseHoldoutExperimentContext.Provider
			value={{
				noSelectionMadeError,
				setNoSelectionMadeError,
				setUserInteracted,
				userInteracted,
				variant,
				shouldUseBlueCards,
			}}
		>
			{children}
		</SunriseHoldoutExperimentContext.Provider>
	);
}
